import { FunctionComponent, useMemo } from 'react'
import { FaTrashAlt, FaInfoCircle } from 'react-icons/fa'

import { MdRemoveRedEye, MdEdit, MdSearch } from 'react-icons/md'
import { HiOutlineDocumentDownload } from 'react-icons/hi'

import { Grid, Tooltip } from '@material-ui/core'
import Text from 'shared/components/Text'
import { colors } from 'shared/styles/colors'
import userProfile from 'shared/config/userProfile'

import {
  Container,
  TableRow,
  THead,
  TBody,
  TableHead,
  TableItem,
  IconButtonStyle,
  StatusComprovante,
} from './styles'
import { ITableNewProps } from './TableNewComponent.types'
import { useAuth } from 'modules/auth/hooks/auth'
import { isUserEditable } from 'shared/utils/isUserEditable'
import ButtonGroup from '../ButtonGroup'
import { format } from 'date-fns'
import { useComprovante } from 'modules/pagamentos/hooks/useComprovante'
import Button from '../Button'

const tableHeadCaminhoesItems = [
  {
    title: 'Nome do caminhão',
  },
  {
    title: 'Placa cavalo',
  },
  {
    title: 'Placa carreta',
  },
  {
    title: 'Placa carreta',
  },
  {
    title: 'Placa carreta',
  },
  {
    title: 'Ações',
  },
  {
    title: 'Status',
  },
]

const tableHeadMotoristasItems = [
  {
    title: 'Nome do motorista',
  },
  {
    title: 'N° CNH',
  },
  {
    title: 'Vencimento da CNH',
  },
  {
    title: 'Cnpj vinculado',
  },
  {
    title: 'Status',
  },
  {
    title: 'Observações',
  },
  {
    title: 'Ações',
  },
]

const tableHeadFrotistaItems = [
  {
    title: 'Nome',
  },
  {
    title: 'CNPJ',
  },
  {
    title: 'E-mail',
  },
  {
    title: 'Status',
  },
  {
    title: 'Observação',
  },
]

const tableHeadUsuarios = [
  {
    title: 'Nome do usuário',
    minWidth: 230,
  },
  {
    title: 'Email',
    minWidth: 230,
  },
  {
    title: 'Perfil de acesso',
  },
  {
    title: 'Status',
  },
  {
    title: 'Usuário alteração',
  },
  {
    title: 'Hora alteração',
  },
  {
    title: 'Ações',
  },
]

const tableHeadComprovantesExtrato = [
  {
    title: 'Tipo',
    minWidth: 230,
  },
  {
    title: 'Data',
  },
  {
    title: 'Status',
  },
  {
    title: '',
  },
]

const TableNew: FunctionComponent<ITableNewProps> = ({
  data,
  type,
  children,
  className,
}) => {
  const { perfil } = useAuth()
  const { tipoComprovante } = useComprovante()

  const renderCaminhaoList = useMemo(
    () => (
      <>
        <THead>
          {!!tableHeadCaminhoesItems.length &&
            tableHeadCaminhoesItems?.map((item, index) => (
              <TableHead key={index}>{item?.title}</TableHead>
            ))}
        </THead>
        <TBody>
          {data &&
            !!data.length &&
            data.map(item => (
              <TableRow key={item?.id}>
                <TableItem>
                  <Grid container>
                    <Grid item md={6}>
                      {item?.descricao}
                    </Grid>

                    <Grid item md={6}>
                      <Tooltip title={item?.frotista?.cnpj} arrow>
                        <Container>
                          {item?.id ? (
                            <FaInfoCircle color={colors.blueLight} />
                          ) : (
                            <></>
                          )}
                        </Container>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </TableItem>
                <TableItem>
                  <Grid container>
                    <Grid item md={6}>
                      {item?.veiculoCavalo?.placa}
                    </Grid>
                    <Grid item md={6}>
                      <Tooltip
                        title={item?.veiculoCavalo?.frotista?.cnpj}
                        arrow
                      >
                        <Container>
                          {item?.veiculoCavalo?.placa ? (
                            <FaInfoCircle color={colors.blueLight} />
                          ) : (
                            <></>
                          )}
                        </Container>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </TableItem>
                <TableItem>
                  <Grid container>
                    <Grid item md={6}>
                      {item?.veiculoCarreta1?.placa}
                    </Grid>
                    <Grid item md={6}>
                      <Tooltip
                        title={item?.veiculoCarreta1?.frotista?.cnpj}
                        arrow
                      >
                        <Container>
                          {item?.veiculoCarreta1?.placa ? (
                            <FaInfoCircle color={colors.blueLight} />
                          ) : (
                            <></>
                          )}
                        </Container>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </TableItem>
                <TableItem>
                  <Grid container>
                    <Grid item md={6}>
                      {item?.veiculoCarreta2?.placa}
                    </Grid>
                    <Grid item md={6}>
                      <Tooltip
                        title={item?.veiculoCarreta2?.frotista?.cnpj}
                        arrow
                      >
                        <Container>
                          {item?.veiculoCarreta2?.placa ? (
                            <FaInfoCircle color={colors.blueLight} />
                          ) : (
                            <></>
                          )}
                        </Container>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </TableItem>
                <TableItem>
                  <Grid container>
                    <Grid item md={6}>
                      {item?.veiculoCarreta3?.placa}
                    </Grid>
                    <Grid item md={6}>
                      <Tooltip
                        title={item?.veiculoCarreta3?.frotista?.cnpj}
                        arrow
                      >
                        <Container>
                          {item?.veiculoCarreta3?.placa ? (
                            <FaInfoCircle color={colors.blueLight} />
                          ) : (
                            <></>
                          )}
                        </Container>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </TableItem>
                <TableItem>
                  {item?.handleView && (
                    <IconButtonStyle onClick={item.handleView} transparent>
                      <MdRemoveRedEye />
                    </IconButtonStyle>
                  )}{' '}
                  {item?.handleEdit && (
                    <IconButtonStyle onClick={item.handleEdit} transparent>
                      <MdEdit />
                    </IconButtonStyle>
                  )}{' '}
                  {item?.handleDelete && (
                    <IconButtonStyle
                      onClick={item.handleDelete}
                      transparent
                      color={colors.blue}
                    >
                      <FaTrashAlt />
                    </IconButtonStyle>
                  )}
                </TableItem>
                <TableItem active={item?.ativo}>
                  {item?.ativo ? '• Ativo' : '• Inativo'}
                </TableItem>
              </TableRow>
            ))}
        </TBody>
      </>
    ),
    [data],
  )
  const renderMotoristaList = useMemo(
    () => (
      <>
        <THead>
          {!!tableHeadMotoristasItems.length &&
            tableHeadMotoristasItems?.map((item, index) => (
              <TableHead key={index}>{item?.title}</TableHead>
            ))}
        </THead>
        <TBody>
          {data &&
            !!data.length &&
            data.map(item => (
              <TableRow key={item?.id}>
                <TableItem>{item?.nome}</TableItem>
                <TableItem>{item?.cnh}</TableItem>
                <TableItem>{item?.vencimento_cnh}</TableItem>
                <TableItem>{item?.frotista?.cnpj}</TableItem>
                <TableItem active={item?.ativo}>
                  {item?.ativo ? (
                    <span style={{ color: colors.green }}>• Ativo</span>
                  ) : item.status === 'PENDENTE' ? (
                    <span style={{ color: colors.orange }}>• Pendente</span>
                  ) : (
                    <span style={{ color: colors.grayLight }}>• Inativo</span>
                  )}
                </TableItem>
                <TableItem scroll={true}>
                  {item.status === 'INVALID' ||
                  item.status === 'MANUAL_REPROVAL' ? (
                    <Grid container style={{ maxHeight: '100%' }}>
                      <Grid item xs={12}>
                        <Text size={12}>
                          {item.protocolo_ocr && (
                            <Text size={12} weight={'bold'}>
                              ({item.protocolo_ocr})
                            </Text>
                          )}
                          {item.mensagem_ocr}
                        </Text>
                        {item?.handleImageModal && (
                          <FaInfoCircle
                            style={{ marginLeft: 5 }}
                            color={colors.blueLight}
                            onClick={() =>
                              item?.handleImageModal(
                                item.id,
                                item.protocolo_ocr,
                              )
                            }
                          />
                        )}
                      </Grid>
                    </Grid>
                  ) : (
                    '-'
                  )}
                </TableItem>
                <TableItem>
                  {item?.handleView && (
                    <IconButtonStyle
                      onClick={() => {
                        if (
                          item.status !== 'INVALID' &&
                          item.status !== 'MANUAL_REPROVAL'
                        ) {
                          item.handleView(item)
                        }
                      }}
                      transparent
                    >
                      <MdRemoveRedEye
                        color={
                          (item.status === 'INVALID' ||
                            item.status === 'MANUAL_REPROVAL') &&
                          colors.grayLight
                        }
                      />
                    </IconButtonStyle>
                  )}{' '}
                  {item?.handleEdit && (
                    <IconButtonStyle
                      onClick={() => {
                        if (
                          item.status !== 'INVALID' &&
                          item.status !== 'MANUAL_REPROVAL'
                        ) {
                          item.handleEdit(item)
                        }
                      }}
                      transparent
                    >
                      <MdEdit
                        color={
                          (item.status === 'INVALID' ||
                            item.status === 'MANUAL_REPROVAL') &&
                          colors.grayLight
                        }
                      />
                    </IconButtonStyle>
                  )}{' '}
                  {item?.handleDelete && (
                    <IconButtonStyle onClick={item.handleDelete} transparent>
                      <FaTrashAlt />
                    </IconButtonStyle>
                  )}
                </TableItem>
              </TableRow>
            ))}
        </TBody>
      </>
    ),
    [data],
  )
  const renderFrotistaList = useMemo(
    () => (
      <>
        <THead>
          {!!tableHeadFrotistaItems.length &&
            tableHeadFrotistaItems?.map((item, index) => (
              <TableHead key={index}>{item?.title}</TableHead>
            ))}
        </THead>
        <TBody>
          {data &&
            !!data.length &&
            data.map(item => (
              <TableRow key={item?.id}>
                <TableItem>
                  {item.is_matriz ? (
                    <strong>{item?.razao_social}</strong>
                  ) : (
                    item?.razao_social
                  )}
                </TableItem>
                <TableItem>
                  {item.is_matriz ? <strong>{item?.cnpj}</strong> : item?.cnpj}
                </TableItem>
                <TableItem>
                  {item.is_matriz ? (
                    <strong>{item?.email}</strong>
                  ) : (
                    item?.email
                  )}
                </TableItem>
                <TableItem>
                  {item?.status === 'VALID' ||
                  item.status === 'MANUAL_APPROVAL' ? (
                    <span style={{ color: colors.green }}>• Ativo</span>
                  ) : item.status === 'INVALID' ||
                    item.status === 'MANUAL_REPROVAL' ? (
                    <span style={{ color: colors.grayLight }}>• Inativo</span>
                  ) : (
                    <span style={{ color: colors.orange }}>• Pendente</span>
                  )}
                </TableItem>
                <TableItem>
                  {item.is_matriz ? (
                    <strong>{item?.mensagem_ocr}</strong>
                  ) : (
                    item?.mensagem_ocr
                  )}
                </TableItem>
              </TableRow>
            ))}
        </TBody>
      </>
    ),
    [data],
  )

  const renderUsuarioVincList = useMemo(() => {
    return (
      <>
        <THead>
          {!!tableHeadUsuarios.length &&
            tableHeadUsuarios?.map((item, index) => (
              <TableHead key={index} style={{ minWidth: item.minWidth || 100 }}>
                {item?.title}
              </TableHead>
            ))}
        </THead>
        <TBody>
          {data &&
            !!data.length &&
            data.map(item => (
              <TableRow key={item?.id}>
                <TableItem style={{ minWidth: 230 }}>{item?.nome}</TableItem>
                <TableItem style={{ minWidth: 230 }}>{item?.login}</TableItem>
                <TableItem>
                  {item?.perfil === userProfile.status.operacional
                    ? 'Operacional'
                    : 'Administrador'}
                </TableItem>
                <TableItem>
                  {item?.ativo ? (
                    <span style={{ color: colors.green }}>• Ativo</span>
                  ) : (
                    <span style={{ color: colors.grayLight }}>• Inativo</span>
                  )}
                </TableItem>
                <TableItem>
                  {item?.usuario_log_id ? item?.usuario_alteracao.nome : ''}
                </TableItem>
                <TableItem>
                  {item?.usuario_log_id
                    ? `${new Date(item?.updated_at).toLocaleDateString(
                        'pt-BR',
                      )} ${new Date(item?.updated_at).toLocaleTimeString(
                        'pt-BR',
                      )} `
                    : ''}
                </TableItem>
                {item?.handleEdit && (
                  <TableItem>
                    <IconButtonStyle onClick={item.handleEdit} transparent>
                      {isUserEditable(perfil, item.perfil) ? (
                        <MdEdit />
                      ) : (
                        <MdSearch />
                      )}
                    </IconButtonStyle>
                  </TableItem>
                )}{' '}
              </TableRow>
            ))}
        </TBody>
      </>
    )
  }, [data, perfil])

  const renderComprovantesExtratoList = useMemo(() => {
    const handleTipoComprovante = (tipo: any): string => {
      return tipoComprovante(tipo)
    }

    const arquivos = (comprovante): Array<string> => {
      const tipos = []
      if (comprovante.extracaoDado?.idDocumento) tipos.push('Em CSV')
      if (comprovante.extracaoDado?.idDocumentoPDF) tipos.push('Em PDF')
      return tipos
    }

    const formataData = (dateInString?: string) => {
      const date = new Date(dateInString)

      return format(date, 'dd/MM/yyyy HH:mm')
    }

    return (
      <>
        <THead>
          {!!tableHeadComprovantesExtrato.length &&
            tableHeadComprovantesExtrato?.map((item, index) => (
              <TableHead key={index} style={{ minWidth: item.minWidth || 100 }}>
                {item?.title}
              </TableHead>
            ))}
        </THead>
        <TBody>
          {data &&
            !!data.length &&
            data.map(comprovante => (
              <TableRow key={comprovante?.id}>
                <TableItem style={{ minWidth: 230 }}>
                  {handleTipoComprovante(comprovante)}
                </TableItem>
                <TableItem>{formataData(comprovante?.dataCriacao)}</TableItem>
                <TableItem>
                  <StatusComprovante status={comprovante?.status} />
                  {comprovante?.status}
                </TableItem>
                <TableItem>
                  {comprovante?.extracaoDado ? (
                    <ButtonGroup
                      disabled={comprovante.status !== 'Disponível'}
                      color={
                        comprovante.status === 'Disponível'
                          ? colors.green
                          : colors.gray
                      }
                      options={arquivos(comprovante)}
                      name="Baixar"
                      onClick={comprovante.handleDownload}
                    >
                      <HiOutlineDocumentDownload />
                    </ButtonGroup>
                  ) : (
                    <Button
                      onClick={comprovante.handleDownload}
                      color={
                        comprovante.status === 'Disponível'
                          ? colors.green
                          : colors.gray
                      }
                      type="button"
                      name="Baixar"
                      disabled={comprovante.status !== 'Disponível'}
                    >
                      Baixar
                    </Button>
                  )}
                </TableItem>
              </TableRow>
            ))}
        </TBody>
      </>
    )
  }, [data])

  return (
    <Container className={className}>
      {type === 'caminhão' && renderCaminhaoList}
      {type === 'motorista' && renderMotoristaList}
      {type === 'frotista' && renderFrotistaList}
      {type === 'usuario_vinc' && renderUsuarioVincList}
      {type === 'comprovantesExtrato' && renderComprovantesExtratoList}
      {children}
    </Container>
  )
}
export default TableNew
